import { Button } from '@eventbrite/eds-button';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import classNames from 'classnames';
import React from 'react';
import rebrandStyles from './PromoCodeCtaText.rebranding.module.scss';

const InputCtaText = ({
    className,
    text,
}: {
    className: string;
    text: string;
}) => <span className={className}>{text}</span>;

const InputLoadingSpinner = () => (
    <ProgressIndicator
        size="small-chunky"
        shape="circular"
        type="indeterminate"
        style="gradient"
    />
);

export interface PromoCodeCtaTextProps {
    isAppRebrandActive: boolean;
    isLoading: boolean;
    isDisabled: boolean;
    ctaText: string;
    onClick?: () => void;
}

export const PromoCodeCtaText: React.FunctionComponent<
    PromoCodeCtaTextProps
> = ({ isAppRebrandActive, isLoading, isDisabled, ctaText, onClick }) => {
    const styles = isAppRebrandActive ? rebrandStyles : {};

    const ctaClassName = classNames('eds-text-bm--fixed', {
        'eds-text-color--ui-blue': !isDisabled && !isAppRebrandActive,
        'eds-text-color--grey-500': isDisabled && !isAppRebrandActive,
        [styles?.cta]: isAppRebrandActive,
    });

    const ctaContent = isLoading ? (
        <InputLoadingSpinner />
    ) : (
        <InputCtaText className={ctaClassName} text={ctaText} />
    );

    return (
        <Button
            style="none"
            onClick={onClick}
            disabled={isDisabled}
            data-automation="promo-code-form-cta-text"
            data-spec="promo-code-form-cta-text"
            data-testid="promo-code-form-cta-text"
        >
            {ctaContent}
        </Button>
    );
};
